import Cookies from 'js-cookie'

import { FeatureFlag } from 'shared/enums/FeatureFlag'
import { useFeatureFlag } from 'featureFlags/hooks/useFeatureFlag'
import getConfig from 'next/config'

const CHECKOUT_COOKIE = 'checkoutCohort'

export const useCheckoutWithRTK = () => {
  const { publicRuntimeConfig } = getConfig()
  const checkoutRtkEnabled = useFeatureFlag(FeatureFlag.TEMP_WEB_FC_CHECKOUT_RTK)

  const cohort = Cookies.get(CHECKOUT_COOKIE)
  const threshold = publicRuntimeConfig.checkoutGqlRtkCohort

  const isWithinCheckoutRTKThreshold =
    cohort && threshold && Number(cohort) <= Number(threshold)
  const displayCheckoutRTK = checkoutRtkEnabled && isWithinCheckoutRTKThreshold

  return { displayCheckoutRTK }
}
